/**
 * Shared layout primitives for `/entities` index pages, to enforce
 * consistency.
 */
import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import PageHeader from 'design-system/components/PageHeader';

export const Backdrop = styled.div`
  position: relative;
  width: 100%;
  padding: ${Spacing[7]} ${Spacing[5]};

  display: flex;
  flex-direction: column;
`;

export const Container = styled('div')`
  position: relative;
  width: 100%;
  padding: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Header = PageHeader;

export const Section = styled('div')`
  width: 100%;
  padding: ${Spacing[7]};
`;
